import QuoteCover from "@/modules/print/quote-cover";
import QuoteDetailSheet from "@/modules/print/quote-detail";
import QuoteRough from "@/modules/print/quote-rough";
import QuoteSchedule from "@/modules/print/quote-schedule";
import QuoteSummary from "@/modules/print/quote-summary";
import { SnapshotData } from "@buildpy/core/modules/quote/types";

interface Props {
  data: SnapshotData;
  /** 현재 조직 정보. 주면 갑지의 회사 정보를 이걸로 덮는다. */
  org?: { name: string; tel: string; address: string };
}

/**
 * 갑지 · 간편견적서 · (시공일정) · 상세견적서. **가견적이면 개산서 한 장.**
 *
 * 일정은 **채운 견적에만** 붙는다 — 이 기능 전에 발송한 스냅샷에는 `schedule` 이
 * 아예 없고, 일정을 안 쓰는 견적도 마찬가지다. 그런 견적서는 지금까지와 똑같이
 * 3부로 나간다.
 *
 * 인쇄하면 장마다 페이지가 넘어가고 화면에서는 종이 느낌 카드가 된다 —
 * 미리보기와 출력물이 따로 놀지 않게.
 *
 * 페이지 나눔·A4 규격은 globals.css 의 `@media print` 가 잡는다.
 */
const QuoteDocument = ({ data, org }: Props) => {
  /**
   * 가견적은 **개산서 한 장**이다. 공종도 항목도 없는 견적에 갑지·간편·상세
   * 3부를 붙이면 고객이 빈 표 두 장을 받는다.
   */
  if (data.rough) return <QuoteRough data={data} org={org} />;

  return (
    <div className="flex flex-col gap-y-4">
      <QuoteCover data={data} org={org} />
      <QuoteSummary data={data} />
      {data.schedule && <QuoteSchedule schedule={data.schedule} />}
      <QuoteDetailSheet data={data} />
    </div>
  );
};

export default QuoteDocument;
